export default __webpack_public_path__ + "src/images/packages/gocheganas-lodge/ffa96f7a489395ced10fdb39c51f6284-2.jpeg";